import { AnyAction } from 'redux';
import {
  App,
  determineLaufzeit,
  JhpVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import {
  GlobalActions,
  TARIF_CHECKED,
  VereinbarungenChanged,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { Produktlinienname, Selbstbeteiligung } from '@ps20/bff-models';
import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { IAppState } from '../appState';
import {
  JhpActions,
  SelbstbeteiligungChangedVorvertragAction,
  TarifCheckedAction,
} from '../jhpActions';

export const jhpVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.JHP, state);

  switch (action.type) {
    case JhpActions.SELBSTBETEILIGUNG_CHANGED:
      return getNewSelbstbeteiligung(
        sectionState,
        action as SelbstbeteiligungChangedVorvertragAction,
      );
    case TARIF_CHECKED:
      return checkTarif(sectionState, action, state);
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.JHP);
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const vorbelegunsDaten: JhpVorbelegungdaten = action.payload;
      if (vorbelegunsDaten.forApp === App.JHP) {
        const dateSplittedBeginn = vorbelegunsDaten.beginnDatum?.split('-');
        const dateSplittedAblauf = vorbelegunsDaten.ablaufDatum?.split('-');
        return {
          ...sectionState,
          beibehalten: true,
          selbstbeteiligung: vorbelegunsDaten.selbstbeteiligung,
          beginnDatum: dateSplittedBeginn
            ? `${dateSplittedBeginn[2]}.${dateSplittedBeginn[1]}.${dateSplittedBeginn[0]}`
            : '',
          aenderungdatum: vorbelegunsDaten.wirksamkeitsbeginn
            ? dayjs(vorbelegunsDaten.wirksamkeitsbeginn).add(1, 'd').format(DATEFORMAT_LOCAL_STATE)
            : sectionState.aenderungdatum,
          ablaufDatum: dateSplittedAblauf
            ? `${dateSplittedAblauf[2]}.${dateSplittedAblauf[1]}.${dateSplittedAblauf[0]}`
            : '',
          ausgewaehltevertragslaufzeit: vorbelegunsDaten.laufzeit,
          vertragslaufzeit: vorbelegunsDaten.laufzeit,
        };
      }
      return sectionState;
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      const kuendigungenPayload = actionPayload.kuendingungChanged.some(elem => {
        return elem.appId === App.JHP;
      });
      if (kuendigungenPayload) {
        newState.vorvertragGekuendigt = true;
      }
      return newState;
    }
    default:
      return sectionState;
  }
};

function getNewSelbstbeteiligung(
  sectionState: IAppState['vertragsoptionen'],
  action: SelbstbeteiligungChangedVorvertragAction,
): IAppState['vertragsoptionen'] {
  const selbstbeteiligung: Selbstbeteiligung = action.payload;
  return { ...sectionState, selbstbeteiligung };
}

function checkTarif(
  sectionState: IAppState['vertragsoptionen'],
  action: TarifCheckedAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  const newState: Vertragsoptionen = cloneDeep(sectionState);
  const newProduktIndex = action.payload.index;
  const produktlinienName = state.produkt.produktlinien[newProduktIndex].produktName;
  determineLaufzeit(action, newState, state.produkt, sectionState);
  newState.versicherungssumme = getVersicherungssumme(produktlinienName);
  return newState;
}

const getVersicherungssumme = (produktLinienName: Produktlinienname): number => {
  return ({
    [Produktlinienname.SMART]: 50000000,
    [Produktlinienname.KOMFORT]: 75000000,
  } as Partial<Record<Produktlinienname, number>>)[produktLinienName];
};
